/**
 * 🔴 ПРАВИЛО ЖЁЛТОГО. `main` (#FFDF17) — цвет ЗАЛИВКИ кнопки. Текст поверх неё
 * красится ТОЛЬКО `btn_text`. Это НЕ цвет текста и НЕ цвет рамки для смысловой
 * пометки.
 *
 * 🔴 Почему именно `btn_text`, а не «чёрный». Тем flip две: `black` = #222 в
 * светлой и #ECECEC в тёмной, `white` = #FFF и #141414. Жёлтый НЕ
 * переворачивается ни в одной. Значит `black` на жёлтом исчезает в тёмной
 * теме, а `white` — в светлой; в обоих случаях сборка зелёная, тесты зелёные,
 * а на экране пусто. Поймано глазами: цифры шагов схемы «Как всё связано»
 * были #ECECEC на #FFDF17. `btn_text` равен #222 в ОБЕИХ темах — он и есть
 * единственный верный ответ. Гейт: locales/../themeContrast.test.ts.
 *
 * Почему записано здесь. На ленте вакансий им были покрашены сразу три вещи:
 * чипы совпавших навыков (жёлтый текст на белом), плашка направления и строка
 * «совпало навыков». Плюс активный чип фильтра — белым по жёлтому. Владелец
 * прошёл экран и сказал прямо: «жёлтым как-то непонятно, читается плохо». Так
 * и есть: контраст #FFDF17 на белом — примерно 1.4:1 при норме 4.5:1.
 *
 * Чем красить смысл вместо жёлтого:
 *   • «у меня это есть», успех      → `signal_green` (рамка/иконка) + обычный текст;
 *   • нейтральная метка, факт       → `bg_gray` + `gray_dark`;
 *   • акцент на числе (зарплата)    → светлый фон + тёмный текст того же тона,
 *                                     а НЕ `marker_green` (#0E6245) заливкой:
 *                                     тёмный текст на тёмно-зелёном не читается.
 */
export enum ColorsTMS {
  main = 'var(--color-main)',
  main_light = 'var(--color-main-light)',
  main_dark = 'var(--color-main-dark)',
  system_gray = 'var(--color-system-gray)',
  white = 'var(--color-white)',
  bg_gray = 'var(--color-bg-gray)',
  additional_gray = 'var(--color-additional-gray)',
  gray = 'var(--color-gray)',
  gray_dark = 'var(--color-gray-dark)',
  black = 'var(--color-black)',
  btn_text = 'var(--color-btn-text)',
  btn_hover_text = 'var(--color-btn-hover-text)',
  signal_red = 'var(--color-signal-red)',
  signal_green = 'var(--color-signal-green)',
  marker_green = 'var(--color-marker-green)',
}

export enum ColorsLearnIT {
  main = 'var(--color-main)',
  main_light = 'var(--color-main-light)',
  main_dark = 'var(--color-main-dark)',
  system_gray = 'var(--color-system-gray)',
  white = 'var(--color-white)',
  bg_gray = 'var(--color-bg-gray)',
  additional_gray = 'var(--color-additional-gray)',
  gray = 'var(--color-gray)',
  gray_dark = 'var(--color-gray-dark)',
  black = 'var(--color-black)',
  btn_text = 'var(--color-btn-text)',
  btn_hover_text = 'var(--color-btn-hover-text)',
  signal_red = 'var(--color-signal-red)',
  signal_green = 'var(--color-signal-green)',
  marker_green = 'var(--color-marker-green)',
}
